<template>
  <div class="withdraw">
    <div class="left-content">
       <div class="description-text">
           <h1 class="description">{{__('Withdraw')}}</h1>
           <a class="btn-green-new" href="https://cryptowallet.llc/" target="_blank">{{__('withdrawal to multiwallet')}}</a>
       </div>
      <div>
          <div class="block-wallets">
              <p class="block-wallets__title">{{__('Available wallet for withdrawal')}}</p>

              <div class="wrap-wallets">
                  <div class="block-wallet" :class="portfolio.withdraw_info.withdraw_main ? 'active' : ''">
                      <div class="block-wallet__left">
                          <div class="block-img" :class="portfolio.withdraw_info.withdraw_main ? '' : 'dis'">
                                <span>
                                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8323 2.625C22.6905 2.625 25.8288 5.76333 25.8288 9.62267V17.9958C25.8288 21.854 22.6905 24.9935 18.8323 24.9935H8.74767C4.8895 24.9935 1.75 21.854 1.75 17.9958V9.62267C1.75 5.76333 4.8895 2.625 8.74767 2.625H18.8323ZM18.8323 4.375H8.74767C5.85433 4.375 3.5 6.72933 3.5 9.62267V17.9958C3.5 20.8892 5.85433 23.2435 8.74767 23.2435H18.8323C21.7257 23.2435 24.0788 20.8892 24.0788 17.9958V17.6692L20.2313 17.6699C18.0181 17.6699 16.2168 15.8697 16.2156 13.6577C16.2156 11.4434 18.017 9.64203 20.2313 9.64087L24.0788 9.64017V9.62267C24.0788 6.72933 21.7257 4.375 18.8323 4.375ZM24.0788 11.3902L20.2313 11.3909C18.9818 11.392 17.9656 12.4082 17.9656 13.6565C17.9656 14.9037 18.983 15.9199 20.2313 15.9199L24.0788 15.9192V11.3902ZM20.7652 12.7092C21.2482 12.7092 21.6402 13.1012 21.6402 13.5842C21.6402 14.0672 21.2482 14.4592 20.7652 14.4592H20.4012C19.9182 14.4592 19.5262 14.0672 19.5262 13.5842C19.5262 13.1012 19.9182 12.7092 20.4012 12.7092H20.7652ZM14.2158 7.91945C14.6988 7.91945 15.0908 8.31145 15.0908 8.79445C15.0908 9.27745 14.6988 9.66945 14.2158 9.66945H7.917C7.434 9.66945 7.042 9.27745 7.042 8.79445C7.042 8.31145 7.434 7.91945 7.917 7.91945H14.2158Z" fill="currentColor"/>
                                    </svg>
                                </span>
                          </div>

                          <div class="block-amount">
                              <span>{{__('Main balance')}}</span>
                              <p :style="portfolio.withdraw_info.withdraw_main ?  {color: '#00C868'} : {color: '#70767D'}">{{$primNum(portfolio.balance)| formatThousands}}</p>
                          </div>
                      </div>

                      <div class="block-checkbox" :class="portfolio.withdraw_info.withdraw_main ? 'active' : ''" v-on:click="wallet = 1">
                          <svg v-if="portfolio.withdraw_info.withdraw_main" width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M3.575 6.175L9.475 0.275C9.65833 0.0916663 9.89167 0 10.175 0C10.4583 0 10.6917 0.0916663 10.875 0.275C11.0583 0.458333 11.15 0.691666 11.15 0.974999C11.15 1.25833 11.0583 1.49167 10.875 1.675L4.275 8.275C4.075 8.475 3.84167 8.575 3.575 8.575C3.30833 8.575 3.075 8.475 2.875 8.275L0.275 5.675C0.0916663 5.49167 0 5.25833 0 4.975C0 4.69167 0.0916663 4.45833 0.275 4.275C0.458333 4.09167 0.691667 4 0.975 4C1.25833 4 1.49167 4.09167 1.675 4.275L3.575 6.175Z" fill="white"/>
                          </svg>
                      </div>
                  </div>

                  <div class="block-wallet" :class="!portfolio.withdraw_info.withdraw_main ? 'active' : ''" >

                      <div class="block-wallet__left">
                          <div class="block-img block-img--partner" :class="!portfolio.withdraw_info.withdraw_main ? '' : 'dis'">
                                <span>
                                    <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.4494 16.3152C11.7129 16.6987 12.035 17.0274 12.445 17.3014C13.0306 17.685 13.704 17.9042 14.4655 17.9042C16.1053 17.9042 17.4524 16.863 17.8623 15.4659C17.9502 15.1918 17.9794 14.918 17.9794 14.6166V14.3152C17.8329 12.8906 16.7495 11.7399 15.344 11.4112C15.0511 11.3562 14.7584 11.3289 14.4655 11.3289C14.3485 11.3289 14.202 11.3289 14.0848 11.3562C14.0262 11.3562 13.9677 11.3562 13.9091 11.3835C12.2401 11.6029 10.9516 12.9727 10.9516 14.6164C10.9516 15.2192 11.1273 15.8219 11.4494 16.3152ZM10.1904 16.3973C9.92686 15.8495 9.78041 15.2467 9.78041 14.6167C9.78041 12.6167 11.2153 10.9455 13.1478 10.3977C13.2648 10.3703 13.4113 10.3428 13.5577 10.3155C13.0892 9.60322 12.5327 9.05514 11.918 8.64429C11.6251 8.42509 11.3029 8.26075 10.9808 8.15125C10.6001 8.01423 10.2488 7.93205 9.89743 7.93205C9.60452 7.93205 9.28239 7.9869 8.98972 8.0964C8.6676 8.20591 8.34551 8.34293 8.0234 8.56212C6.53004 9.49356 5.15377 11.4937 5.15377 14.2332C5.15377 14.4798 5.18297 14.6989 5.30022 14.8908C5.38805 15.11 5.53451 15.2743 5.71016 15.4387C5.91524 15.603 6.17873 15.7674 6.50084 15.8771C7.37916 16.2602 8.81406 16.4246 10.1904 16.3973L10.1904 16.3973ZM20 12.9179C20 13.6302 19.6779 14.2329 19.1801 14.7261L19.1509 14.7535C19.063 17.1096 16.9839 19 14.4656 19C13.0601 19 11.8008 18.4246 10.9517 17.5207C8.63851 17.7125 6.03237 17.3288 4.86096 16.2603C4.74392 16.1508 4.65588 16.0411 4.53884 15.9316C3.0161 15.8219 1.58136 15.4384 0.819911 14.7261C0.29293 14.2331 0 13.6304 0 12.9179C0 11.4386 0.526981 9.79468 1.40551 8.53434C1.84466 7.90426 2.34265 7.41102 2.89886 7.02747C2.9867 6.9453 3.01591 6.8356 3.04532 6.7261C3.07453 6.56175 3.01611 6.36988 2.89886 6.23306C2.37188 5.68517 2.02034 4.94541 2.02034 4.12346C2.02034 2.39743 3.51369 1.00024 5.35854 1.00024C6.20763 1.00024 6.96913 1.30162 7.55473 1.79465C8.19895 1.30161 8.98963 1.02754 9.86795 1.02754C10.8051 1.02754 11.6542 1.35624 12.2984 1.87679C12.884 1.32891 13.7039 1 14.6116 1C16.4565 1 17.9498 2.39718 17.9498 4.12322C17.9498 4.91763 17.6277 5.65738 17.0713 6.23281C16.9542 6.39716 16.9248 6.56151 16.9248 6.72585C16.9248 6.83536 16.9835 6.94505 17.0713 7.02723C17.6277 7.41077 18.1255 7.90402 18.5354 8.53409C19.4435 9.79463 20 11.4383 20 12.9178L20 12.9179ZM18.9166 13.2193C18.9458 13.1371 18.9458 13.0274 18.9458 12.9179C18.9458 9.41114 16.4275 7.2468 14.6413 7.2468C14.0849 7.2468 13.4406 7.466 12.8258 7.84953C13.3528 8.23307 13.8214 8.75362 14.2607 9.35639C14.4658 9.63044 14.6414 9.90428 14.7877 10.2332C16.7204 10.37 18.3015 11.5755 18.9166 13.2194L18.9166 13.2193ZM16.4569 5.35644C16.7204 5.00023 16.8961 4.58934 16.8961 4.12364C16.8961 2.94568 15.8711 1.9867 14.612 1.9867C13.9678 1.9867 13.4114 2.23323 13.0014 2.61678C13.3528 3.16466 13.587 3.79473 13.587 4.45235C13.587 4.94539 13.47 5.38379 13.2941 5.82219C13.6749 6.09623 14.1432 6.23306 14.6412 6.23306C15.2855 6.23306 15.8711 5.98653 16.281 5.57549C16.3104 5.52083 16.3983 5.43866 16.4569 5.35648L16.4569 5.35644ZM12.328 4.39746C12.328 3.10982 11.2152 2.06865 9.83892 2.06865C8.46258 2.06865 7.3498 3.10977 7.3498 4.39746C7.3498 5.6851 8.46258 6.72628 9.83892 6.72628C11.2446 6.72628 12.328 5.68515 12.328 4.39746ZM6.1787 4.47964C6.1787 3.73988 6.41299 3.08246 6.82292 2.53438C6.41298 2.20567 5.91522 2.01379 5.32956 2.01379C4.07052 2.01379 3.04553 2.97277 3.04553 4.15073C3.04553 4.61645 3.19198 5.02752 3.48468 5.38353C3.57251 5.46571 3.63114 5.54788 3.68976 5.63006C4.0997 6.04093 4.68531 6.28763 5.32953 6.28763C5.76868 6.28763 6.17862 6.17812 6.50072 5.95892C6.32506 5.49321 6.17861 5.00014 6.17861 4.4796L6.1787 4.47964ZM5.50526 9.35624C5.94441 8.69867 6.47158 8.17828 7.05723 7.76724C6.50081 7.41102 5.88604 7.21935 5.35885 7.21935C3.57261 7.21935 1.05432 9.38359 1.05432 12.8905C1.05432 13.3289 1.20077 13.6849 1.55209 13.9862C2.02066 14.3971 2.9576 14.6711 4.01177 14.7806C3.95315 14.5888 3.95315 14.3971 3.95315 14.1779C3.95335 12.5616 4.50978 10.7533 5.50533 9.35614L5.50526 9.35624Z" fill="currentColor"/>
                                        <path d="M14.3368 16.6203C13.9456 16.5888 13 16.4938 13 15.9557C13 15.7025 13.1956 15.4811 13.4239 15.4811C13.6195 15.4811 13.9129 15.7343 14.3368 15.7343V14.8482C13.3587 14.5634 13.0328 14.2154 13.0328 13.709C13.0328 12.9494 13.6195 12.4748 14.3368 12.4115V12.1583C14.3368 12.0634 14.4021 12 14.4999 12C14.6302 12 14.6629 12.0634 14.6629 12.1583V12.4115C15.0216 12.4115 15.7064 12.5379 15.7064 13.0128C15.7064 13.2344 15.5433 13.4242 15.3152 13.4242C15.0869 13.4242 14.924 13.2026 14.6632 13.2026V13.9937C15.3152 14.1836 16 14.4683 16 15.2594C16 16.1455 15.2502 16.557 14.6632 16.5885V16.8417C14.6632 16.9366 14.5979 17 14.5001 17C14.3698 17 14.3371 16.9366 14.3371 16.8417L14.3368 16.6203ZM14.3368 13.2026C14.1412 13.2342 14.0107 13.3609 14.0107 13.5823C14.0107 13.7722 14.1737 13.8671 14.3368 13.8989V13.2026ZM14.6955 15.7343C14.891 15.7343 15.0216 15.5445 15.0216 15.3546C15.0216 15.1015 14.8913 15.0065 14.6955 14.9432V15.7343Z" fill="currentColor"/>
                                    </svg>
                                </span>
                          </div>

                          <div class="block-amount">
                              <span>{{__('Partner balance')}}</span>
                              <p :style="!portfolio.withdraw_info.withdraw_main ?  {color: '#F59D00'} : {color: '#70767D'}">{{$primNum(portfolio.balancePartner)| formatThousands}}</p>
                          </div>
                      </div>

                      <div class="block-checkbox" :class="!portfolio.withdraw_info.withdraw_main ? 'active' : ''" v-on:click="wallet = 3">
                          <svg v-if="!portfolio.withdraw_info.withdraw_main" width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M3.575 6.175L9.475 0.275C9.65833 0.0916663 9.89167 0 10.175 0C10.4583 0 10.6917 0.0916663 10.875 0.275C11.0583 0.458333 11.15 0.691666 11.15 0.974999C11.15 1.25833 11.0583 1.49167 10.875 1.675L4.275 8.275C4.075 8.475 3.84167 8.575 3.575 8.575C3.30833 8.575 3.075 8.475 2.875 8.275L0.275 5.675C0.0916663 5.49167 0 5.25833 0 4.975C0 4.69167 0.0916663 4.45833 0.275 4.275C0.458333 4.09167 0.691667 4 0.975 4C1.25833 4 1.49167 4.09167 1.675 4.275L3.575 6.175Z" fill="white"/>
                          </svg>
                      </div>
                  </div>
              </div>
          </div>

        <div class="choose">
          <p class="semi">{{__('Choose a payment method')}}</p>
          <DropdownDefault v-bind:items="filterPayments" v-bind:item_disabled="disableItem" text="name" value_key="payment_id" v-on:change="$emit('update:payment', $payment(form.payment_id))" v-model="form.payment_id" dropSlot>
            <template v-slot:selection="item">
              <span class="img" :class="item.name_class"></span>
              {{item.name}}
            </template>
            <template v-slot:item="item">
              <span class="img" :class="item.name_class"></span>
              <div v-if="item.active">
                {{item.name}}
              </div>
              <div v-else disabled>
                {{item.name}} <span></span>
              </div>
            </template>
          </DropdownDefault>
        </div>
        <div class="amount">
          <div class="left">
            <p class="semi balance-semi">{{__('Amount')}}
              <span v-on:click="balance">
<!--                <img src="/newfrontend/images/total-ms.svg" alt="">-->
                ${{$primNum (wallets.info.available, 2) | formatThousands}}
              </span>
            </p>
            <InputLabelTextDefault
                type="number"
                v-model="form.amount"
                v-bind:errors="formValidate.amount"
                @input="calcSum('give')"
            >

              <template slot="right">
                <span class="usd">USD</span>
              </template>
            </InputLabelTextDefault>
            <!--          <p>{{form.amount_coin/100}} {{payment.currency}}</p>-->
            <!--          <p>{{payment.withdraw_commission}} {{payment.currency}}</p>-->
          </div>
          <div class="right">
            <p class="min">{{__('min. withdrawal 10 USD')}}</p>
            <InputLabelTextDefault
                type="amount_coin"
                :value="$primNum(form.amount_coin- (commissionCoin+ comissionFree), payment.sprintf)"
                disabled
                v-bind:errors="formValidate.amount_coin"
                @input="calcSum( 'get')"
            >
              <template slot="right">
                <span class="usd">{{payment.currency}}</span>
              </template>
            </InputLabelTextDefault>
          </div>
        </div>
        <div v-if="addresses.address">
          <div class="wallet">
            <p class="semi">{{__('Wallet address')}} {{payment.name}}</p>
            <InputLabelTextDefault  :value="addresses.address" disabled></InputLabelTextDefault>
          </div>
          <div v-if="addresses.tag">
            <p>{{__('Tag')}}</p>
            <InputLabelTextDefault  :value="addresses.tag" disabled></InputLabelTextDefault>
          </div>
          <ul class="deposit-text">

            <li>
              <p>{{__('When withdrawing 1% goes to charity.')}}</p>
            </li>
          </ul>
          <div class="btn-one">
            <v-btn
                v-on:click="onSubmit"
                :loading="submitDisabled"
                :disabled="$v.$invalid || (form.amount_coin- (commissionCoin+ comissionFree) < 0)"
                class="btn-site"
            >{{__('Send')}}</v-btn>
          </div>
        </div>
        <div v-else class="dep-btn">
          <p class="semi">{{__('For withdrawal, you need to specify the address in')}}</p>
          <router-link class="btn-site" :to="{name: 'settings', params: {type: 'wallets'}}" color="primary" >{{__('Settings')}}</router-link>
        </div>
      </div>
<!--      <div class="my-office" style="margin-top: 30px;">-->
<!--        <div class="office-2fa">-->
<!--          <div class="more">-->
<!--            <p class="semi">{{__('Withdrawal requests are processed twice a day')}}-->
<!--              <span>{{__('11:00 to 12:00 UTC and 18:00 to 19:00 UTC')}}</span>-->
<!--            </p>-->
<!--              <a class="btn-white-new" v-on:click="modal_cancel= true">{{__('More about withdrawals')}}</a>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="right-content">
      <ul>
        <li>
            <div class="block-img">
                <span>
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M33.6911 7.70882L32.4261 2.64906C32.2751 2.10101 31.9142 1.63457 31.4218 1.3505C30.9296 1.06646 30.3451 0.987683 29.7951 1.13111L5.34344 7.58231H5.17912C4.67596 7.58231 4.19311 7.78222 3.83741 8.13798C3.48171 8.49375 3.28174 8.9766 3.28174 9.47969V18.5237C3.28174 18.8729 3.56494 19.1561 3.91421 19.1561C4.26348 19.1561 4.54668 18.8729 4.54668 18.5237V9.47969C4.54668 9.13042 4.82988 8.84722 5.17915 8.84722H33.0079C33.1756 8.84722 33.3365 8.91385 33.4551 9.03244C33.5737 9.15103 33.6403 9.31197 33.6403 9.47969V17.8919H28.2011C27.6307 17.8919 27.0838 18.1184 26.6806 18.5218C26.2771 18.925 26.0507 19.472 26.0507 20.0423V23.0782C26.0507 23.6485 26.2771 24.1954 26.6806 24.5986C27.0838 25.0021 27.6308 25.2285 28.2011 25.2285H33.6403V31.237C33.6403 31.4047 33.5737 31.5657 33.4551 31.6843C33.3365 31.8028 33.1756 31.8695 33.0079 31.8695H17.8286C17.4793 31.8695 17.1961 32.1527 17.1961 32.502C17.1961 32.8512 17.4793 33.1344 17.8286 33.1344H33.0079C33.511 33.1344 33.9939 32.9345 34.3496 32.5788C34.7053 32.223 34.9052 31.7401 34.9052 31.237V9.48006C34.9055 9.09662 34.7895 8.72254 34.5726 8.4063C34.3558 8.09035 34.0486 7.84724 33.6909 7.70918L33.6911 7.70882ZM30.1114 2.30738C30.5751 2.1854 31.0517 2.45449 31.1866 2.91472L32.3505 7.58228H10.2393L30.1114 2.30738ZM28.2013 23.9632C27.7123 23.9632 27.3158 23.5667 27.3158 23.0777V20.0419C27.3158 19.5528 27.7123 19.1564 28.2013 19.1564H33.6405V23.9632H28.2013Z" fill="#893027"/>
<path d="M33.6911 7.70882L32.4261 2.64906C32.2751 2.10101 31.9142 1.63457 31.4218 1.3505C30.9296 1.06646 30.3451 0.987683 29.7951 1.13111L5.34344 7.58231H5.17912C4.67596 7.58231 4.19311 7.78222 3.83741 8.13798C3.48171 8.49375 3.28174 8.9766 3.28174 9.47969V18.5237C3.28174 18.8729 3.56494 19.1561 3.91421 19.1561C4.26348 19.1561 4.54668 18.8729 4.54668 18.5237V9.47969C4.54668 9.13042 4.82988 8.84722 5.17915 8.84722H33.0079C33.1756 8.84722 33.3365 8.91385 33.4551 9.03244C33.5737 9.15103 33.6403 9.31197 33.6403 9.47969V17.8919H28.2011C27.6307 17.8919 27.0838 18.1184 26.6806 18.5218C26.2771 18.925 26.0507 19.472 26.0507 20.0423V23.0782C26.0507 23.6485 26.2771 24.1954 26.6806 24.5986C27.0838 25.0021 27.6308 25.2285 28.2011 25.2285H33.6403V31.237C33.6403 31.4047 33.5737 31.5657 33.4551 31.6843C33.3365 31.8028 33.1756 31.8695 33.0079 31.8695H17.8286C17.4793 31.8695 17.1961 32.1527 17.1961 32.502C17.1961 32.8512 17.4793 33.1344 17.8286 33.1344H33.0079C33.511 33.1344 33.9939 32.9345 34.3496 32.5788C34.7053 32.223 34.9052 31.7401 34.9052 31.237V9.48006C34.9055 9.09662 34.7895 8.72254 34.5726 8.4063C34.3558 8.09035 34.0486 7.84724 33.6909 7.70918L33.6911 7.70882ZM30.1114 2.30738C30.5751 2.1854 31.0517 2.45449 31.1866 2.91472L32.3505 7.58228H10.2393L30.1114 2.30738ZM28.2013 23.9632C27.7123 23.9632 27.3158 23.5667 27.3158 23.0777V20.0419C27.3158 19.5528 27.7123 19.1564 28.2013 19.1564H33.6405V23.9632H28.2013Z" fill="#00C868"/>
<path d="M31.3633 20.9278H29.8454C29.4961 20.9278 29.2129 21.211 29.2129 21.5603C29.2129 21.728 29.2795 21.8889 29.3981 22.0075C29.5167 22.1261 29.6776 22.1927 29.8454 22.1927H31.3633C31.531 22.1927 31.692 22.1261 31.8105 22.0075C31.9291 21.8889 31.9958 21.728 31.9958 21.5603C31.9958 21.3925 31.9291 21.2316 31.8105 21.113C31.692 20.9944 31.531 20.9278 31.3633 20.9278Z" fill="#893027"/>
<path d="M31.3633 20.9278H29.8454C29.4961 20.9278 29.2129 21.211 29.2129 21.5603C29.2129 21.728 29.2795 21.8889 29.3981 22.0075C29.5167 22.1261 29.6776 22.1927 29.8454 22.1927H31.3633C31.531 22.1927 31.692 22.1261 31.8105 22.0075C31.9291 21.8889 31.9958 21.728 31.9958 21.5603C31.9958 21.3925 31.9291 21.2316 31.8105 21.113C31.692 20.9944 31.531 20.9278 31.3633 20.9278Z" fill="#00C868"/>
<path d="M8.6956 19.7258C6.68268 19.7258 4.75224 20.5254 3.32893 21.9487C1.90562 23.3721 1.10596 25.3025 1.10596 27.3154C1.10596 29.3283 1.90554 31.2588 3.32893 32.6821C4.75231 34.1054 6.68268 34.9051 8.6956 34.9051C10.7085 34.9051 12.639 34.1055 14.0623 32.6821C15.4856 31.2588 16.2853 29.3283 16.2853 27.3154C16.2853 25.3025 15.4857 23.3721 14.0623 21.9487C12.639 20.5254 10.7085 19.7258 8.6956 19.7258ZM8.6956 33.6401C7.01844 33.6401 5.40958 32.9738 4.22342 31.7876C3.03727 30.6014 2.3709 28.9929 2.3709 27.3154C2.3709 25.638 3.03726 24.0294 4.22342 22.8432C5.40959 21.6571 7.01844 20.9907 8.6956 20.9907C10.3731 20.9907 11.9819 21.6571 13.1681 22.8432C14.3539 24.0294 15.0203 25.638 15.0203 27.3154C15.0203 28.9929 14.354 30.6014 13.1681 31.7876C11.9819 32.9738 10.3731 33.6401 8.6956 33.6401Z" fill="#893027"/>
<path d="M8.6956 19.7258C6.68268 19.7258 4.75224 20.5254 3.32893 21.9487C1.90562 23.3721 1.10596 25.3025 1.10596 27.3154C1.10596 29.3283 1.90554 31.2588 3.32893 32.6821C4.75231 34.1054 6.68268 34.9051 8.6956 34.9051C10.7085 34.9051 12.639 34.1055 14.0623 32.6821C15.4856 31.2588 16.2853 29.3283 16.2853 27.3154C16.2853 25.3025 15.4857 23.3721 14.0623 21.9487C12.639 20.5254 10.7085 19.7258 8.6956 19.7258ZM8.6956 33.6401C7.01844 33.6401 5.40958 32.9738 4.22342 31.7876C3.03727 30.6014 2.3709 28.9929 2.3709 27.3154C2.3709 25.638 3.03726 24.0294 4.22342 22.8432C5.40959 21.6571 7.01844 20.9907 8.6956 20.9907C10.3731 20.9907 11.9819 21.6571 13.1681 22.8432C14.3539 24.0294 15.0203 25.638 15.0203 27.3154C15.0203 28.9929 14.354 30.6014 13.1681 31.7876C11.9819 32.9738 10.3731 33.6401 8.6956 33.6401Z" fill="#00C868"/>
<path d="M11.5798 24.9496L7.94927 28.3271L6.12783 26.493C6.01122 26.3741 5.85169 26.3069 5.6851 26.3069C5.51851 26.3069 5.35899 26.3741 5.24237 26.493C5.12266 26.6118 5.05518 26.7733 5.05518 26.9419C5.05518 27.1107 5.12266 27.2723 5.24237 27.3911L7.48146 29.7185C7.59553 29.8414 7.75648 29.9103 7.92419 29.9083C8.0857 29.899 8.23845 29.8315 8.35422 29.7185L12.4398 25.9237C12.6985 25.6863 12.7154 25.2842 12.4779 25.0255C12.2402 24.7672 11.8381 24.7502 11.5798 24.9877L11.5798 24.9496Z" fill="#893027"/>
<path d="M11.5798 24.9496L7.94927 28.3271L6.12783 26.493C6.01122 26.3741 5.85169 26.3069 5.6851 26.3069C5.51851 26.3069 5.35899 26.3741 5.24237 26.493C5.12266 26.6118 5.05518 26.7733 5.05518 26.9419C5.05518 27.1107 5.12266 27.2723 5.24237 27.3911L7.48146 29.7185C7.59553 29.8414 7.75648 29.9103 7.92419 29.9083C8.0857 29.899 8.23845 29.8315 8.35422 29.7185L12.4398 25.9237C12.6985 25.6863 12.7154 25.2842 12.4779 25.0255C12.2402 24.7672 11.8381 24.7502 11.5798 24.9877L11.5798 24.9496Z" fill="#00C868"/>
</svg>

                </span>
            </div>

            <div class="block-text">
                <p class="block-text__title">{{__('Available for withdrawal')}}</p>
                <p class="block-text__subtitle">${{$primNum (wallets.info.available, 2) | formatThousands}}</p>
            </div>
        </li>

        <li>
            <div class="block-img">
                <span>
                    <svg width="32" height="26" viewBox="0 0 32 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.4059 9.75157C16.9926 9.75157 16.6568 9.41574 16.6568 9.00246C16.6568 8.58921 16.9926 8.25334 17.4059 8.25334H26.1152C26.5285 8.25334 26.8644 8.58918 26.8644 9.00246V12.849H31.217C31.6303 12.849 31.9662 13.1848 31.9662 13.5981V24.2473C31.9662 24.6605 31.6303 24.9964 31.217 24.9964H28.294C27.8808 24.9964 27.5449 24.6606 27.5449 24.2473C27.5449 23.834 27.8808 23.4982 28.294 23.4982H30.468V14.347H26.8644V19.6516C26.8644 20.0649 26.5286 20.4008 26.1153 20.4008H6.60579V23.4982H22.9287C23.342 23.4982 23.6778 23.8341 23.6778 24.2473C23.6778 24.6606 23.342 24.9965 22.9287 24.9965H5.85679C5.44354 24.9965 5.10767 24.6606 5.10767 24.2473V20.4008H0.754974C0.341726 20.4008 0.00585938 20.065 0.00585938 19.6517V9.00252C0.00585938 8.58927 0.341696 8.2534 0.754974 8.2534H9.46434C9.87759 8.2534 10.2135 8.58924 10.2135 9.00252C10.2135 9.41577 9.87761 9.75163 9.46434 9.75163H1.50397V18.9028H25.3664V9.75163L17.4059 9.75157ZM9.97068 5.00433C9.66718 5.28347 9.19406 5.26389 8.91515 4.96015C8.636 4.65665 8.65559 4.18353 8.95818 3.90462L12.929 0.236336C13.2168 -0.0291472 13.6586 -0.0250495 13.9416 0.236336L17.9124 3.90462C18.2159 4.18377 18.2355 4.65665 17.9566 4.96015C17.6774 5.26366 17.2036 5.28324 16.8999 5.00433L14.1845 2.49661V11.723C14.6319 11.8512 15.0315 12.0921 15.3507 12.4124C15.8414 12.9031 16.1449 13.5807 16.1449 14.3277C16.1449 15.0759 15.8414 15.7535 15.3507 16.2441C14.8612 16.7348 14.1824 17.0374 13.4354 17.0374C12.6872 17.0374 12.0097 16.7348 11.519 16.2441C11.0295 15.7535 10.7257 15.0759 10.7257 14.3277C10.7257 13.5795 11.0293 12.9019 11.519 12.4124C11.8391 12.0923 12.2387 11.8523 12.6863 11.723V2.49661L9.97092 5.00433H9.97068ZM14.2922 13.4706C14.0729 13.2514 13.7703 13.1161 13.4354 13.1161C13.1005 13.1161 12.7979 13.2523 12.5787 13.4706C12.3594 13.6899 12.2232 13.9925 12.2232 14.3274C12.2232 14.6623 12.3594 14.965 12.5787 15.1842C12.7979 15.4034 13.1005 15.5396 13.4354 15.5396C13.7703 15.5396 14.073 15.4034 14.2922 15.1842C14.5115 14.9649 14.6467 14.6623 14.6467 14.3274C14.6467 13.9925 14.5105 13.6898 14.2922 13.4706Z" fill="#FF0000"/>
                    </svg>
                </span>
            </div>

            <div class="block-text">
                <p class="block-text__title">{{__('Total has been sent')}}</p>
                <p class="block-text__subtitle" style="color: #FF0000">${{$primNum (wallets.info.withdraw, 2) | formatThousands}}</p>
            </div>
        </li>

        <li>
            <div class="block-img">
                <span>
                    <svg width="36" height="22" viewBox="0 0 36 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_4044_10338)">
                            <path d="M10.6869 0.0113831C4.80448 0.0113831 0.0356445 4.77993 0.0356445 10.6627C0.0356445 16.5454 4.80419 21.314 10.6869 21.314C16.5694 21.314 21.3375 16.5454 21.3375 10.6627C21.3375 4.77993 16.569 0.0113831 10.6869 0.0113831ZM10.6869 19.9817C5.54808 19.9817 1.36723 15.8012 1.36723 10.6627C1.36723 5.52411 5.54766 1.34369 10.6862 1.34369C15.8248 1.34369 20.0059 5.52411 20.0059 10.6627C20.0059 15.8012 15.8255 19.9817 10.6869 19.9817Z" fill="#FE9D43"/>
                            <path d="M11.7958 9.99657H11.352V6.88984H14.1478V5.55867H11.352V3.3399L10.0206 3.34018V5.55895H9.57673C8.41717 5.55895 6.69238 6.32709 6.69238 8.44387C6.69238 9.60343 7.46053 11.3282 9.57673 11.3282H10.0206V14.4344H7.22478V15.7655H10.0206V17.9846H11.3517V15.7655H11.7955C12.9551 15.7655 14.6799 14.9974 14.6799 12.8814C14.6804 10.7648 12.9553 9.99649 11.7957 9.99649L11.7958 9.99657ZM9.57676 9.99657C8.11886 9.99657 8.02714 8.69886 8.02357 8.44338C8.02357 6.98548 9.32128 6.89376 9.57676 6.89019H10.0206V9.99693L9.57676 9.99657ZM11.7958 14.4345H11.352V11.3283H11.7914C12.0513 11.3319 13.349 11.4241 13.349 12.8815C13.3488 14.3386 12.0516 14.4308 11.7959 14.4344L11.7958 14.4345Z" fill="#FE9D43"/>
                            <path d="M24.666 3.34076V10.9387L29.3254 15.5987L30.2668 14.6573L25.9972 10.3877V3.34097L24.666 3.34076Z" fill="#FE9D43"/>
                            <path d="M25.3308 0.011424C22.9757 0.011424 20.8062 0.785129 19.043 2.0792C19.3634 2.39124 19.6676 2.71944 19.9515 3.06545C21.4729 1.98477 23.3265 1.34287 25.3308 1.34287C30.4696 1.34287 34.6497 5.52329 34.6497 10.6619C34.6497 15.8004 30.4693 19.9816 25.3308 19.9816C23.3265 19.9816 21.4729 19.3394 19.9515 18.259C19.6676 18.6047 19.3631 18.9332 19.043 19.2452C20.8063 20.5394 22.9755 21.313 25.3308 21.313C31.2132 21.3133 35.982 16.5447 35.982 10.6624C35.982 4.78011 31.2135 0.0111389 25.3308 0.0111389V0.011424Z" fill="#FE9D43"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_4044_10338">
                                <rect width="36" height="21.3432" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                </span>
            </div>

            <div class="block-text">
                <p class="block-text__title">{{__('In processing for withdrawal')}}</p>
                <p class="block-text__subtitle" style="color: #FE9D43">${{$primNum (wallets.info.pending, 2) | formatThousands}}</p>
            </div>
        </li>
      </ul>

       <div class="access-withdraw">
           <p v-if="portfolio.withdraw_info.withdraw_main" class="access-withdraw__title">{{__('Remaining time for the formation of a request for withdrawal')}}</p>
           <p v-else class="access-withdraw__title">{{__('Before the start of the formation of the request for withdrawal left')}}</p>
           <div class="block-timer" :class="portfolio.withdraw_info.withdraw_main ? '' : 'partner'">
               <div class="block-timer__item">
                   <span class="num ">{{days}}</span>
                   <p class="txt">{{__('days')}}</p>
               </div>
               <div class="block-timer__item">
                   <span class="num">{{hours}}</span>
                   <p class="txt">{{__('hours')}}</p>
               </div>
               <div class="block-timer__item">
                   <span class="num">{{minutes}}</span>
                   <p class="txt">{{__('minutes')}}</p>
               </div>
               <div class="block-timer__item">
                   <span class="num">{{seconds}}</span>
                   <p class="txt">{{__('seconds')}}</p>
               </div>
           </div>

           <p class="access-withdraw__description">{{__('You can withdraw funds from the main account on Tuesdays every two weeks. These days, withdrawals from the affiliate wallet are not available.')}}</p>

           <a class="btn-white-new" v-on:click="modal_cancel= true">{{__('More about withdrawals')}}</a>
       </div>
    </div>
    <WithdrawStep2 v-if="withdraw_info" v-bind:withdraw.sync="withdraw_info" v-bind:comission_free="comissionFree" v-bind:commission_coin="commissionCoin" @updateDeposit="updateDeposit" v-bind:addresses="addresses"></WithdrawStep2>

    <ModalDefault v-if="modal_cancel" v-bind:modal_cancel.sync="modal_cancel">
        <div class="window-site window-more">
            <p>{{__('The withdrawal of funds from the Mediachain platform takes place in several stages.')}}</p>
            <p>{{__('Stage 1 - the user creates a request for withdrawal and it goes to the financial department.')}}</p>
            <p>{{__('Stage 3 - Cryptocurrencies go to a special payment service that automatically processes applications and sends money from various wallets (during the deposit, 1 hour is given to replenish it for this) so that the hacker could not steal money at the time of deposit / withdrawal.')}}</p>
            <p>{{__('Stage 4 - the payment service processes each application in turn, checking the network wallet and the withdrawal amount, and from 2 to 72 hours funds are received on the users wallet, depending on the selected blockchain.')}}</p>
            <p>{{__('Important: the “pending” status will be visible in the personal account until the user’s funds exit the payment system.')}}</p>
        </div>
    </ModalDefault>

    <ModalWithdrawClosed
        v-if="withdraw_closed"
        v-bind:withdraw_closed.sync="withdraw_closed"
    />
  </div>
</template>

<script>
    import moment from "moment";
    import WithdrawStep2 from "./WithdrawStep2";
    import InputLabelTextDefault from "../../modules/InputLabelTextDefault";
    import {required, minValue,maxValue, decimal, numeric} from "vuelidate/lib/validators";
    import DropdownDefault from "../../modules/DropdownDefault";
    import _ from 'lodash';
    import ModalWithdrawClosed from "./ModalWithdrawClosed";
    import ModalDefault from "../../modules/ModalDefault";

    export default {
        data () {
            return {
                submitDisabled: false,
                withdraw_info: null,
                withdraw_closed: false,
                modal_cancel: false,
                withdraw_more: false,
                formValidate: {
                    payment_id: null,
                    amount: null,
                    amount_coin: null,
                },
                form: {
                    payment_id: this.payment.payment_id,
                    amount: 50,
                    amount_coin: 0,
                },

                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0,
                timeinterval: null,
            }
        },
        watch: {
            payment() {
                this.form.amount= 50;
                this.calcSum('give');
            },
            payment_id(payment_id) {
                this.$emit('update:payment', this.$payment(payment_id));
            }
        },
        created() {
            this.calcSum();
            this.initializeClock();
            this.updateClock();
        },
        props: {
            payment: {
                type: Object
            },
            wallets: {
                type: Object
            }
        },
        computed: {
            filterPayments() {
                let payments= this.$cleanObject(this.payments);

                return  _.filter(payments, {withdraw: 1});
            },
            comissionFree() {
                return Number(this.$primNum(this.form.amount_coin/100, this.payment.sprintf))
            },
            portfolio() {
                return this.$store.state.auth.portfolio;
            },
            payments() {
                return this.$store.state.auth.payments
            },
            addresses() {
                let index= this.$filterIndexObject(this.wallets.payment, this.form.payment_id, 'payment_id');

                return this.wallets.payment[index];
            },
            commissionCoin() {
                let amount= this.form.amount_coin;
                let payment= this.payment;

                let commission= payment.withdraw_commission;

                if(payment.withdraw_pay_commission== 'percent') {
                    commission += (amount/100)* payment.replenish_commission
                }

                return Number(this.$primNum(commission, payment.sprintf));
            }
        },
        validations() {
            return {
                form: {
                    amount_coin: {
                        required,
                        decimal
                    },
                    amount: {
                        required,
                        decimal,
                        minValue: minValue(50),
                        // limit: maxValue((200/this.payment.course_usd)- ((this.portfolio.sum_invest) ? this.portfolio.sum_invest : 0))
                        maxValue: (this.portfolio.withdraw_info.withdraw_main) ? maxValue(this.portfolio.balance) : maxValue(this.portfolio.balancePartner)

                        // maxValue: maxValue(this.payment.max_replenish*this.payment.course_usd)
                    },
                    payment_id: {
                        required,
                        numeric
                    },
                }
            }
        },
        methods: {
          balance(){
            this.form.amount = (this.$primNum(this.wallets. balance, 2));
            this.calcSum('give');
          },
            calcSum(type= 'give') {
                let payment= this.payment;
                if(type== 'get') {
                    let val= this.form.amount_coin;


                    let calc_get= this.$primNum((val*payment.course_usd), 2);
                    this.form.amount= calc_get;
                } else {
                    let val= this.form.amount;
                    let calc_give= this.$primNum(val/payment.course_usd, payment.sprintf);
                    this.form.amount_coin= Number(calc_give);
                }
                this.updateValidate('amount');
            },
            disableItem(item) {
                if (item.disabled === 1) {
                    return true;
                } else {
                    return false;
                }
            },
            updateDeposit() {

                let valid= this.$v.form;
                if(valid.$invalid) {
                    let massages= {
                        'amount': [],
                        'amount_coin': [],
                        'payment_id': [],
                    };
                    this.formValidate= this.$formValidate(massages, valid);
                } else {
                    this.submitDisabled = true;

                    let form = this.form;

                    form.wallet = (this.portfolio.withdraw_info.withdraw_main) ? 1 : 3;

                    let response = form;

                    this.$http[(process.env.NODE_ENV === 'production') ? 'post' : 'get']('ajax/'+((this.reinvest== 2) ? 'deposit/reinvest' : 'withdraw/create'), response)
                        .then(response => {
                            return response.json()
                        })
                        .then((response) => {
                            this.$store.dispatch('asyncResp', response.resp_tickets);
                            response= response.data;

                            this.submitDisabled= false;
                            this.withdraw_info= null;

                            if(response.action) {
                                let form = document.createElement('form');
                                form.action= response.action;
                                form.method= response.method;
                                Object.keys(response.form).forEach(key => {
                                    form.innerHTML += '<input type="hidden" name="'+key+'" value="'+response.form[key]+'">';
                                });
                                document.body.append(form);
                                form.submit();
                            } else if (response.url) {
                                location.href= response.url;
                            } else {
                                //2 step
                                this.withdraw_info = null;
                                this.$router.push({name: 'transactions'});
                            }
                        }).catch((err) => {
                        this.submitDisabled = false;
                        this.httpHandler(err);

                        if(response.error) {
                            this.formValidate = response.error.message;
                        }
                    });
                }
            },
            moment: function () {
                return moment();
            },
            updateValidate: function(type) {
                this.formValidate= this.$changeValidate(this.formValidate, this.$v.form[type], type);
            },
            onSubmit() {
                let valid= this.$v.form;
                if(valid.$invalid) {
                    let massages= {
                        'amount': [],
                        'amount_coin': [],
                        'payment_id': [],
                    };
                    this.formValidate = this.$formValidate(massages, valid);
                } else {
                    this.submitDisabled = true;

                    this.$http[(process.env.NODE_ENV === 'production') ? 'get' : 'get']('ajax/withdraw/allow')
                    .then(response => {
                        return response.json()
                    })
                    .then((response) => {
                        this.submitDisabled= false;
                        this.$store.dispatch('asyncResp', response.resp_tickets);
                        response = response.data;

                        if (response.withdraw) {
                            this.withdraw_info = this.form;
                        } else {
                            this.withdraw_closed = true;
                        }
                    })
                    .catch((err) => {
                        this.submitDisabled = false;
                        this.httpHandler(err);
                    });
                }
            },
            initializeClock() {
                this.timeinterval = setInterval(this.updateClock, 1000);
            },

            updateClock() {
                let x = moment.utc(this.portfolio.withdraw_info.withdraw_time).format('x') - moment.utc().format('x');
                let seconds = Math.floor((x / 1000) % 60);
                let minutes = Math.floor((x / 1000 / 60) % 60);
                let hours = Math.floor((x / (1000 * 60 * 60)) % 24);
                let days = Math.floor(x / (1000 * 60 * 60 * 24));

                let t = {
                    'total': x,
                    'days': days,
                    'hours': hours,
                    'minutes': minutes,
                    'seconds': seconds
                };

                if (t.days < 10) {
                    t.days = '0' + t.days;
                }
                if (t.hours < 10) {
                    t.hours = '0' + t.hours;
                }
                if (t.minutes < 10) {
                    t.minutes = '0' + t.minutes;
                }
                if (t.seconds < 10) {
                    t.seconds = '0' + t.seconds;
                }

                this.days = t.days;
                this.hours = t.hours;
                this.minutes = t.minutes;
                this.seconds = t.seconds;

                if (t.total <= 0) {
                    clearInterval(this.timeinterval);
                    this.days = '00';
                    this.hours = '00';
                    this.minutes = '00';
                    this.seconds = '00';
                }
            },
        },
        components: {
            ModalDefault,
            DropdownDefault,
            WithdrawStep2,
            InputLabelTextDefault,
            ModalWithdrawClosed
        }
    }
</script>

<style scoped>

</style>
